<h2 mat-dialog-title>Add workshop job</h2>
<form [formGroup]="form">
  <mat-dialog-content>
    @if (showTemplateSelect) {
      <div class="flex flex-col justify-start items-stretch max-w-full">
        <div
          class="flex max-w-full md:flex-row flex-col justify-start items-stretch md:items-center md:justify-between space-y-2 md:space-y-0 md:space-x-4 pb-4"
        >
          <p class="flex-shrink">
            Search for a template that has already been created using the box
            below. If you want to manage your existing templates or create a new
            one go to
            <a [routerLink]="['/workshop', 'templates']" target="_blank"
              >Workshop Templates</a
            >.
          </p>
          <button
            mat-stroked-button
            color="primary"
            class="flex flex-grow flex-shrink-0"
            type="button"
            (click)="toggleUseTemplate(false)"
          >
            <p class="whitespace-nowrap px-2">Enter Manually</p>
          </button>
        </div>

        @if (!form.get('template_id').value) {
          <app-template-select
            (templateSelected)="templateSelected($event)"
          ></app-template-select>
        } @else {
          <p class="text-xl">You have selected {{ selectedTemplate.name }}.</p>
        }
      </div>
    } @else {
      <div
        class="flex md:flex-row flex-col justify-start items-stretch md:items-center md:justify-between space-y-2 md:space-y-0 md:space-x-4 pb-4"
      >
        <p [testId]="testIds.ADD_WORKSHOP_JOB_DESCRIPTION" class="flex-shrink">
          You are adding a workshop job for {{ data.name }}. Fill in the details
          below to create the job.
        </p>
        <button
          mat-stroked-button
          class="flex-grow flex-shrink-0"
          color="primary"
          type="button"
          (click)="toggleUseTemplate(true)"
        >
          <p class="whitespace-nowrap">Use a Template</p>
        </button>
      </div>
      <div class="flex flex-col items-stretch">
        <mat-form-field>
          <mat-label>Type</mat-label>
          <mat-select
            formControlName="type"
            name="type"
            [testId]="testIds.WORKSHOP_JOB_TYPE_DROPDOWN"
          >
            <mat-option *ngFor="let type of types" [value]="type">
              {{ type }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field [testId]="testIds.DEFECT_DETAILS_INPUT">
          <mat-label>Defect details</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="2"
            cdkAutosizeMaxRows="4"
            formControlName="details"
            name="details"
          ></textarea>
        </mat-form-field>
        <mat-form-field [testId]="testIds.ADD_JOB_NOTES_INPUT">
          <mat-label>Notes</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="2"
            cdkAutosizeMaxRows="4"
            formControlName="notes"
            name="notes"
          ></textarea>
        </mat-form-field>
      </div>
    }
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-flat-button mat-dialog-close [testId]="testIds.CANCEL_ADD_JOB">
      Cancel
    </button>
    <button
      [testId]="testIds.SAVE_ADD_JOB_BUTTON"
      mat-flat-button
      (click)="submit()"
      [disabled]="form.invalid"
    >
      Add
    </button>
  </div>
</form>
